import { render } from "./suspendWizard.vue?vue&type=template&id=90d2594c"
import script from "./suspendWizard.vue?vue&type=script&lang=js"
export * from "./suspendWizard.vue?vue&type=script&lang=js"

import "./suspendWizard.vue?vue&type=style&index=0&id=90d2594c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__